const state = {
    showCartItemDialog: false,
    newCartItemAmazonProductId: null,
};

const getters = {
    newCartItemAmazonProduct(state, getters, rootState) {
        return (state.newCartItemAmazonProductId) ? rootState.data.amazonProducts.byId[state.newCartItemAmazonProductId] : null;
    },
};

const actions = {
    newCartItem({ commit }, { amazonProduct } = {}) {
        commit('NEW_CARTITEM', { amazonProduct });
    },
    editCartItem({ commit }, { cartItem }) {
        commit('EDIT_CARTITEM', { cartItem });
    },
    closeCartItemDialog({ commit }) {
        commit('CLOSE_CARTITEM_DIALOG');
    },
};

const mutations = {
    CLEAR_ALL(state) {
        state.showCartItemDialog = false;
        state.newCartItemAmazonProductId = null;
    },
    NEW_CARTITEM(state, { amazonProduct }) {
        state.showCartItemDialog = true;
        state.newCartItemAmazonProductId = (amazonProduct) ? amazonProduct.id : null;
    },
    CLOSE_CARTITEM_DIALOG(state) {
        state.showCartItemDialog = false;
        state.newCartItemAmazonProductId = null;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
